<script lang="ts">
	import SiteFooter from '$lib/components/site-footer.svelte';
	import SiteHeader from '$lib/components/site-header.svelte';
	import TailwindIndicator from '$lib/components/tailwind-indicator.svelte';
	import { dev } from '$app/environment';

	let { children, data } = $props();
</script>

<SiteHeader navigation={data.navigation} />
<div class="flex-1">
	{@render children?.()}
</div>
<SiteFooter footer={data.footer} />
{#if dev}
	<TailwindIndicator />
{/if}
